/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Learn_Attemptcountother2Inputs */

const zh_learn_attemptcountother2 = /** @type {(inputs: Learn_Attemptcountother2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次作答`)
};

const en_learn_attemptcountother2 = /** @type {(inputs: Learn_Attemptcountother2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} attempts`)
};

const es_learn_attemptcountother2 = /** @type {(inputs: Learn_Attemptcountother2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} intentos`)
};

/**
* | output |
* | --- |
* | "{count} attempts" |
*
* @param {Learn_Attemptcountother2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_attemptcountother2 = /** @type {((inputs: Learn_Attemptcountother2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Attemptcountother2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_attemptcountother2(inputs)
	if (locale === "en") return en_learn_attemptcountother2(inputs)
	return es_learn_attemptcountother2(inputs)
});
export { learn_attemptcountother2 as "learn_attemptCountOther" }